import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const destinations = [
  {
    name: 'France',
    description: 'Côte d\'Azur & Paris',
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=2000',
  },
  {
    name: 'Vouliagmeni, Greece',
    description: 'Athenian Riviera',
    image: 'https://static.wixstatic.com/media/55275b_fe399810339043a0820680de4627fe5a~mv2.jpg/v1/fill/w_1919,h_786,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/55275b_fe399810339043a0820680de4627fe5a~mv2.jpg',
  },
  {
    name: 'Belgrade, Serbia',
    description: 'Emerging Luxury Market',
    image: 'https://customer-assets.emergentagent.com/job_elite-properties-18/artifacts/bpo16lc2_projekat_lokali_izdavanje_YADerlkeWP-Green-Hill-0.jpg',
  },
  {
    name: 'Marrakesh, Morocco',
    description: 'North African Elegance',
    image: 'https://images.unsplash.com/photo-1597212618440-806262de4f6b?q=80&w=2000',
  },
];

const Destinations = () => {
  const { t } = useTranslation();
  
  return (
    <section className="section-padding" style={{ background: '#f6f5e8' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6">{t.destinations.title}</h2>
          <div className="w-20 h-px bg-gray-300 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {destinations.map((destination, index) => (
            <div
              key={index}
              className="group cursor-pointer hover-lift"
              style={{ background: '#fffef2', borderRadius: '0px', overflow: 'hidden' }}
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={destination.image}
                  alt={destination.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/40 group-hover:from-black/20 group-hover:to-black/50 transition-all duration-300"></div>
              </div>
              
              <div className="p-6">
                <h3 className="heading-2 mb-2" style={{ fontSize: '20px' }}>{destination.name}</h3>
                <p className="body-small mb-4" style={{ color: '#666666' }}>{destination.description}</p>
                <button className="btn-secondary flex items-center gap-2" style={{ fontSize: '12px' }}>
                  {t.destinations.discover}
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Destinations;